var map = {
	"./ad.svg": 13494,
	"./ae.svg": 76206,
	"./af.svg": 64894,
	"./ag.svg": 21618,
	"./ai.svg": 43665,
	"./al.svg": 17138,
	"./am.svg": 34808,
	"./ao.svg": 39803,
	"./ar.svg": 71210,
	"./as.svg": 8213,
	"./at.svg": 68104,
	"./au.svg": 92970,
	"./aw.svg": 14435,
	"./az.svg": 17991,
	"./ba.svg": 19267,
	"./bb.svg": 82094,
	"./bd.svg": 31582,
	"./be.svg": 26580,
	"./bf.svg": 47078,
	"./bg.svg": 31745,
	"./bh.svg": 94780,
	"./bi.svg": 34407,
	"./bj.svg": 52439,
	"./bm.svg": 25116,
	"./bo.svg": 64349,
	"./br.svg": 59338,
	"./bs.svg": 78952,
	"./bt.svg": 60671,
	"./bw.svg": 70673,
	"./by.svg": 52198,
	"./bz.svg": 7522,
	"./ca.svg": 80277,
	"./cd.svg": 89486,
	"./cf.svg": 61979,
	"./cg.svg": 99838,
	"./ch.svg": 71824,
	"./ci.svg": 68563,
	"./ck.svg": 8096,
	"./cl.svg": 43544,
	"./cm.svg": 27407,
	"./cn.svg": 40299,
	"./co.svg": 67319,
	"./cr.svg": 50645,
	"./cu.svg": 5585,
	"./cv.svg": 68025,
	"./cw.svg": 71767,
	"./cy.svg": 72618,
	"./cz.svg": 9549,
	"./de.svg": 94046,
	"./dj.svg": 6129,
	"./dk.svg": 11650,
	"./dm.svg": 13102,
	"./do.svg": 15350,
	"./dz.svg": 3576,
	"./ec.svg": 4950,
	"./ee.svg": 64506,
	"./eg.svg": 67533,
	"./er.svg": 1793,
	"./es.svg": 10311,
	"./et.svg": 79110,
	"./fi.svg": 10566,
	"./fj.svg": 51957,
	"./fk.svg": 29887,
	"./fm.svg": 50315,
	"./fo.svg": 44725,
	"./fr.svg": 31072,
	"./ga.svg": 57831,
	"./gb.svg": 6625,
	"./gd.svg": 34760,
	"./ge.svg": 4559,
	"./gg.svg": 75514,
	"./gh.svg": 69608,
	"./gi.svg": 14118,
	"./gl.svg": 9455,
	"./gm.svg": 71525,
	"./gn.svg": 72538,
	"./gq.svg": 51246,
	"./gr.svg": 32776,
	"./gt.svg": 41571,
	"./gu.svg": 97342,
	"./gw.svg": 16727,
	"./hk.svg": 68544,
	"./hn.svg": 24273,
	"./hr.svg": 10046,
	"./ht.svg": 47808,
	"./hu.svg": 87210,
	"./id.svg": 74404,
	"./ie.svg": 12611,
	"./il.svg": 44038,
	"./im.svg": 44071,
	"./in.svg": 33043,
	"./io.svg": 53078,
	"./iq.svg": 63012,
	"./ir.svg": 56830,
	"./is.svg": 68706,
	"./it.svg": 76722,
	"./je.svg": 82377,
	"./jm.svg": 55326,
	"./jo.svg": 98387,
	"./jp.svg": 34133,
	"./ke.svg": 69557,
	"./kg.svg": 97211,
	"./kh.svg": 80212,
	"./ki.svg": 77279,
	"./km.svg": 44775,
	"./kn.svg": 46380,
	"./kp.svg": 80166,
	"./kr.svg": 759,
	"./kw.svg": 98400,
	"./ky.svg": 38482,
	"./kz.svg": 56454,
	"./la.svg": 93519,
	"./lb.svg": 10032,
	"./li.svg": 39217,
	"./lk.svg": 87817,
	"./lr.svg": 78022,
	"./ls.svg": 49773,
	"./lt.svg": 88824,
	"./lu.svg": 14400,
	"./lv.svg": 92763,
	"./ly.svg": 93649,
	"./ma.svg": 94415,
	"./mc.svg": 72411,
	"./md.svg": 29859,
	"./me.svg": 58572,
	"./mg.svg": 72497,
	"./mh.svg": 52449,
	"./mk.svg": 31163,
	"./ml.svg": 15088,
	"./mm.svg": 74340,
	"./mn.svg": 55330,
	"./mo.svg": 37224,
	"./mp.svg": 86365,
	"./mq.svg": 79614,
	"./mr.svg": 19523,
	"./ms.svg": 26095,
	"./mt.svg": 60871,
	"./mu.svg": 78619,
	"./mv.svg": 25346,
	"./mw.svg": 24763,
	"./mx.svg": 47328,
	"./my.svg": 90366,
	"./mz.svg": 48943,
	"./na.svg": 10730,
	"./nato.svg": 22424,
	"./ne.svg": 7692,
	"./nf.svg": 70192,
	"./ng.svg": 43390,
	"./ni.svg": 27014,
	"./nl.svg": 39843,
	"./no.svg": 96384,
	"./np.svg": 44363,
	"./nr.svg": 62724,
	"./nu.svg": 83888,
	"./nz.svg": 3944,
	"./om.svg": 3780,
	"./pa.svg": 65129,
	"./pe.svg": 66770,
	"./pf.svg": 75106,
	"./pg.svg": 18472,
	"./ph.svg": 33318,
	"./pk.svg": 86912,
	"./pl.svg": 64669,
	"./pn.svg": 71664,
	"./pr.svg": 73816,
	"./ps.svg": 40315,
	"./pt.svg": 39087,
	"./pw.svg": 29635,
	"./py.svg": 55101,
	"./qa.svg": 51004,
	"./ro.svg": 83385,
	"./rs.svg": 33859,
	"./ru.svg": 58990,
	"./rw.svg": 24136,
	"./sa.svg": 51764,
	"./sb.svg": 68322,
	"./sc.svg": 24335,
	"./sd.svg": 49729,
	"./se.svg": 13438,
	"./sg.svg": 21070,
	"./si.svg": 86747,
	"./sk.svg": 26177,
	"./sl.svg": 23900,
	"./sm.svg": 81022,
	"./sn.svg": 98318,
	"./so.svg": 62488,
	"./sr.svg": 69073,
	"./ss.svg": 55526,
	"./st.svg": 56509,
	"./sv.svg": 46465,
	"./sx.svg": 42729,
	"./sy.svg": 34089,
	"./sz.svg": 5601,
	"./tc.svg": 33115,
	"./td.svg": 5842,
	"./tg.svg": 90878,
	"./th.svg": 51249,
	"./tibet.svg": 71233,
	"./tj.svg": 61207,
	"./tk.svg": 55164,
	"./tm.svg": 16626,
	"./tn.svg": 88355,
	"./to.svg": 37671,
	"./tr.svg": 59781,
	"./tt.svg": 36076,
	"./tv.svg": 58513,
	"./tw.svg": 7357,
	"./tz.svg": 56972,
	"./ua.svg": 11796,
	"./ug.svg": 85383,
	"./us.svg": 89305,
	"./uy.svg": 89081,
	"./uz.svg": 61718,
	"./ve.svg": 53074,
	"./vi.svg": 28794,
	"./vn.svg": 60449,
	"./vu.svg": 71521,
	"./ws.svg": 27454,
	"./ye.svg": 78526,
	"./za.svg": 70646,
	"./zm.svg": 54726,
	"./zw.svg": 7963
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52107;